<template lang="html">
  <div class="labels-sheet">
    <div class="item-cells">
      <div
        class="item-cell"
        v-for="explanation in newExp"
        @click="track(explanation)"
      >
        <div class="item-cell-hd">
          <img :src="explanation.image" alt="" />
        </div>
        <div class="item-cell-bd">
          <p class="labTitle">{{ explanation.title }}</p>
          <p class="label">{{ explanation.fu_title }}</p>
        </div>
        <div class="item-cell-ft" v-if="explanation.link !== ''">
          <i class="iconfont icon-youjiantou"></i>
        </div>
        <a
          :href="explanation.link"
          v-if="explanation.link !== ''"
          class="link"
        ></a>
      </div>
    </div>
    <TextExplanation
      :level4CategoryId="product.level4CategoryId"
      :exp="yuerTextExplanation"
    ></TextExplanation>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TextExplanation from '@/components/common/textExplanation'
import Popup from '@/components/action-sheet/popup'
import PROUDCT_TYPE from '@/router/home/components/product/product-intro/config'

export default {
  props: {
    params: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState(['mainConfig', 'product', 'selectedSku']),
    yuerTextExplanation() {
      return this.mainConfig && this.mainConfig.yuerTextExplanation
    },
    serveExplanation() {
      //成长加商品不支持picc
      if (+this.product.spuType !== PROUDCT_TYPE.YU_ER) {
        if (this.mainConfig && this.mainConfig.serviceWarrantyDes) {
          return this.mainConfig.serviceWarrantyDes.filter(
            ele => ele.name !== 'picc_acc'
          )
        }
        return null
      }
      return (this.mainConfig && this.mainConfig.serviceWarrantyDes) || []
    },
    newExp() {
      const { giveInsure = 0 } = this.selectedSku || {}
      // 不可退
      const refund = this.serveExplanation.filter(
        ele => ele.name === 'refund_supply'
      )[0]
      // 随时退
      const return_anytime = this.serveExplanation.filter(
        ele => ele.name === 'refund_anytime'
      )[0]
      // 过期退
      const return_overdue = this.serveExplanation.filter(
        ele => ele.name === 'refund_overdue'
      )[0]
      // 其他显示
      const other_exp = this.serveExplanation.filter(
        ele =>
          ele.name !== 'refund_supply' &&
          ele.name !== 'refund_anytime' &&
          ele.name !== 'refund_overdue'
      )
      let left_exp = []
      // if (this.product.refund_supply === 0 && refund) { // 0: 不可退, 1:可退
      //     left_exp.push(refund)
      // } else {
      //     if (this.product.refund_overdue === 1 && return_overdue) {
      //         left_exp.push(return_overdue)
      //     }
      //     if (this.product.refund_anytime === 1 && return_anytime) {
      //         left_exp.push(return_anytime)
      //     }
      // }

      if (
        this.product.isAnyTimeRefund === 0 &&
        this.product.isExpiredRefund === 0
      ) {
        left_exp.push(refund)
      } else {
        if (this.product.isAnyTimeRefund === 1) {
          left_exp.push(return_anytime)
        }
        if (this.product.isExpiredRefund === 1) {
          left_exp.push(return_overdue)
        }
      }
      if (giveInsure) {
        left_exp.push({
          title: '最高100万保险',
          fu_title:
            '购买门票类产品，可免费领取最高100万保险。（保障详情请在下单页查看）',
          link: '',
          image:
            'https://hzwimspic-1251601690.image.myqcloud.com/c833125b-720b-4f34-9631-1c5ebe00df1e'
        })
      }
      // if (this.product.isSchedule * 1 === 1) {
      //     lb.push({ title: '需预约', isGood: true })
      // } else {
      //     lb.push({ title: '过期退', isGood: true })
      // }
      // return lb;
      left_exp = left_exp.concat(other_exp)
      return left_exp
    }
  },
  methods: {
    track(explanation) {
      if (explanation.link !== '') {
      }
    },
    couldShow(item) {
      if (item.name === 'refund_anytime') {
        return item.isGood === 1 && this.params.product.refund_anytime === 1
      } else if (item.name === 'refund_overdue') {
        return item.isGood === 1 && this.params.product.refund_overdue === 1
      } else if (item.name === 'refund_supply') {
        return item.isGood === 1 && this.params.product.refund_supply === 1
      } else {
        return item.isGood === 1
      }
    }
  },
  components: {
    TextExplanation,
    Popup
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';

.labels-sheet {
  .item-cell {
    padding: 0 rem(25px) rem(36px);
    display: flex;
    align-items: flex-start;
    &:last-child {
      padding-bottom: rem(20px);
    }
  }
  .item-cell-hd {
    display: inline-block;
    padding-right: rem(20px);
    line-height: 1;

    img {
      width: rem(30px);
      height: rem(30px);
    }
    .unuse {
      color: #999;
    }
  }
  .link {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
  }
  .icon-youjiantou {
    font-size: rem(40px);
  }
  .item-cell-bd {
    .labTitle {
      font-weight: 600;
    }
    .label {
      color: #666;
      font-size: rem(26px);
      margin-top: rem(10px);
      line-height: rem(42px);
    }
  }
}
</style>
